// @ts-nocheck
import React from 'react'
import { COLOR, JARGON, LAYOUT, SCROLLBAR, VIEW } from "../../modules/constants"

//#region mui
import { withStyles } from '@mui/styles'

// mui
import Checkbox from '@mui/material/Checkbox'
import SvgIcon from '@mui/material/SvgIcon'
import { CustomCheckbox } from "../../pages/companiesHouse/pageFunctions/checkboxFunctions"

import Box from "@mui/material/Box"
import Divider from '@mui/material/Divider'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import ListItem from '@mui/material/ListItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ToggleButton from '@mui/material/ToggleButton'
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup'
import Typography from "@mui/material/Typography"

import Tooltip from '@mui/material/Tooltip'

import TableIcon from "@mui/icons-material/GridOn"
import ScatterPlotOutlinedIcon from "@mui/icons-material/ScatterPlotOutlined"
import BarChartRoundedIcon from '@mui/icons-material/BarChartRounded'
import { CheckBoxOutlineBlank, ExpandLess, ExpandMore } from '@mui/icons-material'

import Scrollbars from "react-custom-scrollbars-2"

const styles = () => ({
  menuLandscape: {
    width: LAYOUT.LANDSCAPE_MENU_WIDTH,
    minWidth: LAYOUT.LANDSCAPE_MENU_WIDTH,
    paddingLeft: LAYOUT.COLUMN_PADDING,
    overflowX: "hidden",
    overflowY: "auto",
    marginTop: 4,
  },
  menuPortrait: {
    width: "100%",
    padding: `0px ${LAYOUT.COLUMN_PADDING}px 0px ${LAYOUT.COLUMN_PADDING}px`,
    // paddingBottom: 10,
    borderBottom: "2px solid lightgrey",
  },
  checkbox: {
    height: 22,
  },
})

const NexusMenuOption = ({ clickable, color, disabled, icon, onClick, portrait, rollupStatus, selected, text, tooltipTitle }) => (
  <Tooltip disableHoverListener={!tooltipTitle} placement="top" title={tooltipTitle ?? ""}>
    <ListItem
      button={clickable && !selected}
      onClick={(clickable && selected) ? null : onClick}
      disabled={clickable && disabled}
      selected={selected}
      dense
      style={{ color: color, minHeight: 40 }}>
      <ListItemIcon style={{ color: color, minWidth: 35 }}>
        {icon}
      </ListItemIcon>

      <Typography noWrap={portrait} style={{ fontSize: 14, fontWeight: clickable && !selected ? "normal" : "bold" }}>
        {text}
      </Typography>
      {clickable ? rollupStatus ? <ExpandLess /> : <ExpandMore /> : ""}
    </ListItem>
  </Tooltip >
)

// Outline (no fill) checkbox glyphs, so a selected/indeterminate checkbox reads as a colored
// perimeter + colored tick/dash rather than a solid colored square with a white cutout
const OutlinedCheckedIcon = props => (
  <SvgIcon {...props}>
    <rect x="3" y="3" width="18" height="18" rx="3" fill="none" stroke="currentColor" strokeWidth="2" />
    <path d="M7 12.5l3 3 7-7" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </SvgIcon>
)

const OutlinedIndeterminateIcon = props => (
  <SvgIcon {...props}>
    <rect x="3" y="3" width="18" height="18" rx="3" fill="none" stroke="currentColor" strokeWidth="2" />
    <line x1="7" y1="12" x2="17" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </SvgIcon>
)

const NexusMenuCheckbox = ({ checked, classes, color, disabled, dontColorUnchecked, handleChange, indent, indeterminate, label, labelColor, noneChecked, opacity, portrait, selected, tooltipTitle }) => (
  <Tooltip disableHoverListener={!tooltipTitle} placement="top" title={tooltipTitle ?? ""}>
    <FormControl className={classes.checkbox}
      style={selected
        ? portrait
          // Wider gap than landscape's: in portrait these checkboxes wrap onto multiple lines within
          // the full-width menu (landscape's narrow single-column sidebar never wraps), and 5px between
          // wrapped lines is too tight a touch target gap on mobile.
          ? { width: LAYOUT.LANDSCAPE_MENU_WIDTH - (3 * LAYOUT.COLUMN_PADDING), opacity: opacity, paddingLeft: 0, marginBottom: 16 }
          : { paddingLeft: indent, width: LAYOUT.LANDSCAPE_MENU_WIDTH - (2 * LAYOUT.COLUMN_PADDING) - indent, opacity: opacity, marginBottom: 5 }
        : portrait
          ? { width: LAYOUT.LANDSCAPE_MENU_WIDTH - (3 * LAYOUT.COLUMN_PADDING), opacity: opacity, paddingLeft: 0, marginBottom: 16 }
          : { paddingLeft: indent, width: LAYOUT.LANDSCAPE_MENU_WIDTH - (2 * LAYOUT.COLUMN_PADDING) - indent, opacity: opacity, marginBottom: 5 }
      }
    >
      <FormControlLabel
        control={noneChecked && !dontColorUnchecked // Use custom checkbox if none are checked
          ? <CustomCheckbox
            onChange={handleChange}
            indeterminate={indeterminate}
          />
          : <Checkbox
            checked={checked}
            checkedIcon={<OutlinedCheckedIcon />}
            disabled={disabled} // Possible MUI only
            indeterminateIcon={<OutlinedIndeterminateIcon />}
            onChange={handleChange}
            style={checked || indeterminate ? { color: color } : {}} // checkbox checked/indeterminate color
            indeterminate={indeterminate}
          />}
        label={noneChecked && !dontColorUnchecked
          ? <span style={{ fontWeight: "bold", fontSize: 14, color: COLOR.BAD }} > {label} </span> // checkbox label text color
          : <span style={{ fontSize: 14, color: (!checked && !disabled) ? COLOR.BLACK : labelColor }} > {label} </span>} // checkbox label text color
      />
    </FormControl>
  </Tooltip>
)

const checkboxIndicatorIcon = ({ allItemsChecked, noneChecked, someChecked, iconColor }) => {
  const style = { fontSize: 24, verticalAlign: 'middle', marginRight: 9, color: iconColor, marginBottom: 5 }
  if (allItemsChecked) return <OutlinedCheckedIcon style={style} />
  if (someChecked) return <OutlinedIndeterminateIcon style={style} />
  if (noneChecked) return <CheckBoxOutlineBlank style={style} />
  return null
}

const NexusMenuText = ({ allItemsChecked, clickable, color, dontColorUnchecked, noneChecked, onClick, opacity, rollupStatus, someChecked, text, tooltipTitle }) => {
  const collapsed = clickable && !rollupStatus
  const warningColor = noneChecked && !dontColorUnchecked
  const textStyle = warningColor ? { color: COLOR.BAD } : { color: color, opacity }
  const expandStyle = warningColor ? { color: COLOR.BAD } : { color: "black", opacity }
  const iconColor = warningColor ? COLOR.BAD : (color || "black")

  return (
    <ListItem
      button={clickable}
      onClick={clickable ? onClick : null}
      style={{ paddingLeft: 0, paddingTop: 8, paddingBottom: 0 }}
    >
      <Tooltip disableHoverListener={!tooltipTitle} placement="top" title={tooltipTitle ?? ""}>
        <Typography
          // textTransform (not fontVariant: "small-caps") - small-caps needs the browser to synthesise
          // small capitals from the font's regular glyphs, which some mobile browsers/OS font-substitution
          // tables get wrong at this weight, rendering the text in italics on a subset of devices.
          // fontWeight 700 (not 600) - the self-hosted Roboto webfont has no real 600-weight file
          // (public/index.html declares a 600 @font-face but its font files don't exist), so browsers
          // fall back to a substituted OS font for that weight, which on some Windows setups renders italic
          style={{ ...textStyle, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}
        >
          {collapsed && checkboxIndicatorIcon({ allItemsChecked, noneChecked, someChecked, iconColor })}
          {text}
        </Typography>
      </Tooltip>

      {clickable
        ? rollupStatus
          ? <ExpandLess style={expandStyle} />
          : <ExpandMore style={expandStyle} />
        : ""
      }
    </ListItem>
  )
}

// Icon-only segmented control for switching between the Table / Diagram / Timeline views.
// The active view is shown via ToggleButtonGroup's own selected styling, rather than a
// disabled-looking button that reads the same as a genuinely locked (unsubscribed) view.
const NexusMenuViewButtons = ({ features, portrait, viewButtons }) => {
  const nexusView = viewButtons.nexusView

  const timelineTip = "click to view as timeline"

  const buttons = [
    {
      value: VIEW.TABLE,
      icon: <TableIcon fontSize="medium" />,
      tip: nexusView === VIEW.TABLE ? "already viewing as table" : "click to view as table",
    },
    {
      value: VIEW.D3,
      icon: <ScatterPlotOutlinedIcon fontSize="medium" />,
      tip: nexusView === VIEW.D3 ? "already viewing as diagram" : "click to view as diagram",
    },
    {
      value: VIEW.TIMELINE,
      icon: <BarChartRoundedIcon fontSize="medium" style={{ transform: 'rotate(90deg)' }} />,
      tip: !features.TimeLine
        ? timelineTip + JARGON.SUBSCRIBED_USERS_ONLY
        : nexusView === VIEW.TIMELINE ? "already viewing as timeline" : timelineTip,
      disabled: !features.TimeLine,
    },
  ]

  return (
    <ToggleButtonGroup
      value={nexusView}
      exclusive
      onChange={(event, newValue) => { if (newValue !== null) viewButtons.handleChangeView(newValue) }}
      size="small"
      sx={{ width: `calc(100% - ${LAYOUT.COLUMN_PADDING}px)`, mt: "8px" }}
    >
      {buttons.map(({ value, icon, tip, disabled }) => (
        <ToggleButton
          key={value}
          value={value}
          disabled={disabled}
          sx={{ flex: 1, aspectRatio: portrait ? "3 / 1" : "3 / 2", ...(portrait ? { maxHeight: 56 } : {}) }}
        >
          <Tooltip disableInteractive placement="top" title={tip}>
            <span style={{ display: "flex" }}>{icon}</span>
          </Tooltip>
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}

const NexusMenu = ({ classes, children, portrait }) => (
  <Box id="nexus-menu" className={portrait ? classes.menuPortrait : classes.menuLandscape} >
    {!portrait && <Scrollbars autoHide
      autoHideTimeout={SCROLLBAR.AH_TIMEOUT}
      autoHideDuration={SCROLLBAR.AH_DURATION}>
      {children}
    </Scrollbars>}

    {portrait && children}

  </Box>
)

NexusMenu.Checkbox = withStyles(styles)(NexusMenuCheckbox)
NexusMenu.Option = withStyles(styles)(NexusMenuOption)
NexusMenu.Text = withStyles(styles)(NexusMenuText)
NexusMenu.ViewButtons = withStyles(styles)(NexusMenuViewButtons)

NexusMenu.Divider = () =>
  <div style={{ paddingTop: 16 }}>
    <Divider variant="middle" style={{ background: COLOR.MID_GREY }} />
  </div>

export default withStyles(styles)(NexusMenu)


